export default {
	PUT_LOGGED(state, payload) {
		state = payload;
	}, PUT_USER_ID(state, payload) {
		state.user.id = payload;
	}
};



// WEBPACK FOOTER //
// ./sources/domains/logged/mutations.js